import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import useRequest from '../../hooks/useRequest'
import AppRoutes from '../../routes/appRoutes'

const LogoutPage = () => {
    const { handleLogout, impersonated, role, authenticated } = useAuth()
    const { clearRequests } = useRequest()

    useEffect(() => {
        handleLogout()
        clearRequests()
    }, [])

    useEffect(() => {
        if (!impersonated && role !== 'admin' && window.Intercom != null) {
            window.Intercom('shutdown')
        }
    }, [impersonated, role])

    return !authenticated ? <Redirect to={AppRoutes.login()} /> : null
}

export default LogoutPage
